/* ======================================================================== */
/* 55. SliderImages */
/* ======================================================================== */
var SliderImages = function ($scope) {

	var $slider = $scope.find('.js-slider-images');

	if (!$slider.length) {
		return;
	}

	$slider.each(function () {

		var $current = $(this);

		var
			lg = window.elementorFrontend ? window.elementorFrontend.config.breakpoints.lg - 1 : 1024,
			md = window.elementorFrontend ? window.elementorFrontend.config.breakpoints.md - 1 : 767;

		var slider = new Swiper($current, {
			autoHeight: $current.data('auto-height') || true,
			speed: $current.data('speed') || 1200,
			preloadImages: false,
			lazy: {
				loadPrevNext: true,
				loadOnTransitionStart: true
			},
			observer: true,
			watchSlidesProgress: true,
			watchSlidesVisibility: true,
			slidesPerGroup: 1, // compatibility with Swiper 5.x
			centeredSlides: $current.data('centered-slides') || false,
			slidesPerView: $current.data('slides-per-view') || 1.5,
			autoplay: {
				enabled: $current.data('autoplay-enabled') || false,
				delay: $current.data('autoplay-delay') || 6000,
			},
			spaceBetween: $current.data('space-between') || 80,
			pagination: {
				el: '.js-slider-images-progress',
				type: 'progressbar',
				progressbarFillClass: 'slider__progressbar-fill',
				renderProgressbar: function (progressbarFillClass) {
					return '<div class="' + progressbarFillClass + '"></div>'
				}
			},
			navigation: {
				nextEl: '.js-slider-images__next',
				prevEl: '.js-slider-images__prev',
			},
			breakpointsInverse: true // compatibility with both Swiper 4.x and 5.x
		});
		
		slider.params.breakpoints = {
			[lg]: {
				centeredSlides: $current.data('centered-slides') || false,
				slidesPerView: $current.data('slides-per-view') || 1.5,
				spaceBetween: $current.data('space-between') || 80,
			},
			[md]: {
				slidesPerView: $current.data('slides-per-view-tablet') || 1.33,
				spaceBetween: $current.data('space-between-tablet') || 30,
				centeredSlides: $current.data('centered-slides-tablet') || true,
			},
			0: {
				slidesPerView: $current.data('slides-per-view-mobile') || 1.33,
				spaceBetween: $current.data('space-between-mobile') || 30,
				centeredSlides: $current.data('centered-slides-mobile') || true,
			}
		};

		slider.update();

		slider
			// update height after images are loaded
			.on('lazyImageReady', function () {
				slider.update();
			})
			// cursor position adjustment
			.on('touchMove', function (e) {
				if (typeof window.InteractiveCursor !== 'undefined') {
					window.InteractiveCursor.mouseX = e.clientX;
					window.InteractiveCursor.mouseY = e.clientY;
				}
			});

		// update height after images are loaded
		slider.on('lazyImageReady', function () {
			slider.update();
		});

		$slider.imagesLoaded().progress({
			background: true
		}, function (e) {
			setTimeout(function () {
				slider.update();
			}, 300);
		});

		renderSliderCounter(
			slider,
			$current.find('.js-slider-images-counter-current'),
			'',
			$current.find('.js-slider-images-counter-total')
		);

	});

}
